import { render } from "./odn-modal-emergency-numbers-filters.vue?vue&type=template&id=bfdb4fda"
import script from "./odn-modal-emergency-numbers-filters.vue?vue&type=script&lang=js"
export * from "./odn-modal-emergency-numbers-filters.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__